import React, { useState, useEffect, useContext, useRef } from 'react';
import { useAPI, Button, AuthContext } from 'components/lib';
import FieldTreePopover from './fieldTreePopover';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import styles from './styles.module.css';

export function RuleOperation(props) {

  const authContext = useContext(AuthContext);
  const [expressionVal, setExpressionVal] = useState(null);
  const fieldButtonRef = useRef(null);

  const fieldList = useAPI(props.recordType ? '/api/appData/fieldList/'+ props.recordType : null);
  const [nodes, setNodes] = useState(null);
  useEffect(() => {
    if(fieldList.loading === true){
      return;
    }

    // console.log(JSON.stringify(fieldList.data))
    setNodes(fieldList.data);
    
  }, [fieldList]);
  
  const operations = [
    { name: '= (equals)', code: '=' },
    { name: '!= (not equal to)', code: '!=' },
    { name: '< (less than)', code: '<' },
    { name: '<= (less than or equal to)', code: '<=' },
    { name: '> (greater than)', code: '>' },
    { name: '> (greater than or equal to)', code: '>=' },
    { name: 'starts with', code: 'startswith' },
    { name: 'in (is in the list)', code: 'in' }
  ];

  const values = [
    { name: '"" (blank value)', code: '""' },
    { name: 'True', code: 'True' },
    { name: 'False', code: 'False' },
    { name: 'Text (matches)', code: 'text' },
    { name: 'Numeric Value', code: 'numeric' },
    { name: 'Select a Field', code: 'field' },
    { name: 'Select a Date', code: 'date' },
  ];
  
    const [editId, setEditId] = useState("");
    // Track which popover is open: 'field', 'value', or null
    const [openPopover, setOpenPopover] = useState(null);

    function checkExpressionVal(id, value) {
      console.log(value)
      if((value === 'date') || (value === 'field') || (value === 'text') || (value === 'numeric')) {
        setExpressionVal(value)
      } else {
        setExpressionVal(null);
        props.editRuleCondition(id, "value", value)
      }
    }
  
    // function setExpressionValue(val) {

    //   if(val === null) {
    //     val = '';
    //   }
    //   else {
    //     val = val.toString();
    //   }

    //   setExpressionVal(val)
    // }

    function toggleEdit(id) {
      if(id === editId) {
        setEditId("");
      }
      else {
        setEditId(id);
      }
    }
  
    const renderFieldName = (query) => {
      try {
      // console.log("query - " + query)

      // Step 1: Remove '$..'
      let cleanedQuery = query.replace('$..', '');
      
      // Remove '[*]'
      cleanedQuery = cleanedQuery.replace(/\[\*\]/g, '');

      // Step 2: Replace '.' with '->'
      cleanedQuery = cleanedQuery.replace(/\./g, ' : ');

      // Step 3: Split words on capital letters and add spaces
      cleanedQuery = cleanedQuery.replace(/([A-Z])/g, ' $1').trim(); // Add space before capital letters
      cleanedQuery = cleanedQuery.charAt(0).toUpperCase() + cleanedQuery.slice(1); // Capitalize the first letter

      return cleanedQuery;
      }
      catch {
        return query;
      }
    }
    const renderJSON = (json, depth) => {
      const style = {
        marginLeft: `${depth * 20}px`, // Adjust the indentation level as needed
      };
  
      if (json.expression) {
        return (
          <>
          <div style={style} className={depth === 0 ? styles.surroundingOutermostNode : styles.surroundingNode}>
            
            {json.operands &&
              json.operands.map((operand, index) => (
                <div key={index}>
                  {renderJSON(operand, depth=depth + 1)}
                  {index !== json.operands.length-1 &&
  
                    <div style={style} className={styles.expression} >
                      <Button className={styles.operatorBtn} text={json.expression.toUpperCase()} small textOnly action={() => props.toggleExpression(json.id)} />
                    </div>
                  }
  
                </div>
              ))}
          </div>
          { authContext.hasAccountSetting("edit_rules") === true &&
            <div style={{textAlign: 'center', marginTop: '12px'}}>
              <Button 
                icon="plus-circle"
                action={() => props.addOperand(json.id)}
                className={styles.createRuleBtn}
                text="Add Condition Group"
                iconPosition="left"
              />
            </div>
          }
          </>
        );
      } else {
        return (
          <div style={style} className={styles.jsonNode}>
            {(json.id !== editId) &&
              <div className={styles.conditionContainer}>
                <div className={styles.conditionDisplay}>
                  <span className={styles.fieldName}>
                    {renderFieldName(json.field)}
                  </span>
                  <span className={styles.operator}>
                    {json.operator}
                  </span>
                  <span className={styles.fieldValue}>
                    {(json.value || json.value !== "") ? renderFieldName(json.value) : "\"\""}
                  </span>
                </div>
                { authContext.hasAccountSetting("edit_rules") === true &&
                  <div className={styles.conditionActions}>
                    <Button 
                      icon="edit"
                      small
                      className={`${styles.panelButton} ${styles.panelButtonPrimary}`}
                      action={() => toggleEdit(json.id)}
                      text="Edit"
                      iconPosition="left"
                    />
                    <Button 
                      icon="trash"
                      small
                      className={`${styles.panelButton} ${styles.panelButtonDanger}`}
                      action={() => props.removeRuleCondition(json.id)}
                      text="Delete"
                      iconPosition="left"
                    />
                    <Button 
                      icon="plus-circle"
                      small
                      className={`${styles.panelButton} ${styles.panelButtonPrimary}`}
                      action={() => props.addRuleCondition(json.id)}
                      text="Add"
                      iconPosition="left"
                    />
                  </div>
                }
              </div>
            }
  
            {(json.id === editId) &&
              <div className={styles.editExpression}>
                <div style={{marginBottom: '16px'}}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}>
                    <i className="pi pi-pencil" style={{color: '#6b7280'}}></i>
                    Edit Condition
                  </div>
                  <div className={styles.conditionDisplay}>
                    {renderFieldName(json.field)} {json.operator} {(json.value || json.value !== "") ? renderFieldName(json.value) : "\"\""}
                  </div>
                </div>
                
                <div className={styles.editSelectorGroup}> 
                  <div className={styles.formField}>
                    <label className={styles.formLabel}>
                      Field
                    </label>
                    {/* Modern popover field selector */}
                    <div style={{ position: 'relative' }}>
                    <button
                        type="button"
                        className={styles.formInput}
                        style={{ width: '100%', textAlign: 'left', cursor: 'pointer', background: 'white', color: '#374151', fontWeight: 500 }}
                        onClick={() => setOpenPopover('field')}
                      >
                        {json.field ? renderFieldName(json.field) : 'Select Field'}
                      </button>
                      {openPopover === 'field' && (
                        <FieldTreePopover
                          nodes={nodes}
                          selected={json.field}
                          onSelect={(key) => { props.editRuleCondition(json.id, "field", key); setOpenPopover(null); }}
                          anchorRef={fieldButtonRef}
                          onClose={() => setOpenPopover(null)}
                        />
                      )}
                    </div>
                  </div>
                  
                  <div className={styles.formField}>
                    <label className={styles.formLabel}>
                      Operator
                    </label>
                    <Dropdown 
                      style={{width: '100%'}} 
                      options={operations} 
                      optionLabel="name" 
                      onChange={(e) => props.editRuleCondition(json.id, "operator", e.value.code)}
                      className="w-full" 
                      placeholder={json.operator ? json.operator : 'Select Operator'} 
                    />
                  </div>

                  <div className={styles.formField}>
                    <label className={styles.formLabel}>
                      Value
                    </label>
                    {expressionVal !== 'field' && expressionVal !== 'date' && expressionVal !== 'text'  && expressionVal !== 'numeric' &&
                    <Dropdown 
                      style={{width: '100%'}} 
                      options={values} 
                      optionLabel="name" 
                      value={expressionVal} 
                      onChange={(e) => checkExpressionVal(json.id, e.value.code)}
                      className="w-full" 
                      placeholder={json.value ? renderFieldName(json.value) : "Select Value Type"} 
                    />
                    }

                    {expressionVal === 'field' &&
                    <div style={{ display: 'flex', gap: '8px', position: 'relative' }}>
                      <button
                        type="button"
                        className={styles.formInput}
                        style={{ flex: 1, textAlign: 'left', cursor: 'pointer', background: 'white', color: '#374151', fontWeight: 500 }}
                        onClick={() => setOpenPopover('value')}
                      >
                        {json.value ? renderFieldName(json.value) : 'Select Field'}
                      </button>
                      {openPopover === 'value' && (
                        <FieldTreePopover
                          nodes={nodes}
                          selected={json.value}
                          onSelect={(key) => { checkExpressionVal(json.id, key); setOpenPopover(null); }}
                          anchorRef={fieldButtonRef}
                          onClose={() => setOpenPopover(null)}
                        />
                      )}
                      <Button
                        icon="x"
                        small
                        className={styles.panelButton}
                        action={() => checkExpressionVal(json.id, '')}
                        style={{
                          minWidth: '36px',
                          height: '36px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        iconPosition="left"
                      />
                    </div>
                    }

                    {expressionVal === 'date' &&
                    <div style={{display: 'flex', gap: '8px'}}>
                      <Calendar 
                        value={expressionVal} 
                        dateFormat='mm/dd/yyyy' 
                        showButtonBar 
                        onChange={(e) => checkExpressionVal(json.id, new Intl.DateTimeFormat("en-US", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit"
                        }).format(e.value))}
                        style={{flex: 1}}
                      />
                      <Button 
                        icon="x"
                        small
                        className={styles.panelButton}
                        action={() => checkExpressionVal(json.id, '')}
                        style={{
                          minWidth: '36px',
                          height: '36px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        iconPosition="left"
                      /> 
                    </div>
                    }

                    {expressionVal === 'text' &&
                    <div style={{display: 'flex', gap: '8px'}}>
                      <InputText 
                        value={json.value ? json.value : ''} 
                        onChange={(e) => props.editRuleCondition(json.id, "value", e.target.value)}
                        style={{flex: 1}}
                        placeholder="Enter text value"
                      />
                      <Button 
                        icon="x"
                        small
                        className={styles.panelButton}
                        action={() => checkExpressionVal(json.id, '')}
                        style={{
                          minWidth: '36px',
                          height: '36px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        iconPosition="left"
                      />
                    </div>
                    }

                    {expressionVal === 'numeric' &&
                    <div style={{display: 'flex', gap: '8px'}}>
                      <InputText 
                        keyfilter="num" 
                        value={!isNaN(json.value) ? json.value : 0} 
                        onChange={(e) => props.editRuleCondition(json.id, "value", e.target.value)}
                        style={{flex: 1}}
                        placeholder="Enter numeric value"
                      />
                      <Button 
                        icon="x" 
                        small 
                        className={styles.panelButton}
                        action={() => checkExpressionVal(json.id, '')}
                        style={{
                          minWidth: '36px',
                          height: '36px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      />
                    </div>
                    }

                  </div>
                </div>
                
                <div style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '8px',
                  marginTop: '24px',
                  paddingTop: '16px',
                  borderTop: '1px solid #e5e7eb'
                }}>
                  <Button 
                    icon="check"
                    small
                    className={styles.panelButton}
                    action={() => toggleEdit(json.id)}
                    style={{
                      background: '#10b981',
                      color: 'white',
                      border: 'none'
                    }}
                    text="Done"
                    iconPosition="left"
                  />
                </div>
              </div>
            }
          </div>
        );
      }
    };
  
    return (
      <div style={{width: '100%'}}>
        <div className={styles.surroundingOutermostNode}>
          {renderJSON(props.data, 0)}
          
          <div className={styles.notificationTrigger}>
            <div className={styles.notificationTitle}>
              <i className={`pi pi-info-circle ${styles.notificationIcon}`}></i>
              Notification Trigger
            </div>
            <div className={styles.notificationText}>
              If all the conditions above are TRUE, then this monitor{' '}
              <Button 
                className={styles.operatorBtn} 
                textOnly 
                small 
                text={props.success === true ? "WILL NOT" : "WILL"} 
                action={() => props.toggleRuleSuccess()}
              />{' '}
              trigger a notification.
            </div>
          </div>
        </div>
      </div>
    );
  }